// @flow
import EventEmitter from '@common/services/EventEmitter';
import ApiService from '@api/service';

import type { Error, Listener, QueryParams } from '@core/types';

import { API_PATHS } from '@app/constants/paths';

const { SMS_EXPORT_SUMMARY, SMS_EXPORT_DETAIL } = API_PATHS;

type OnChange = (listener: Listener) => Function;
type FetchExport = (params: QueryParams, exportType: string) => Promise<boolean | null>;
type UpdateValues = (newLoading: boolean, newErrors: Error[]) => void;
type Trigger = () => void;

class GroupClassSmsExportService {
  constructor() {
    this.eventEmitter = new EventEmitter();
    this.errors = [];
    this.loading = false;
  }

  eventEmitter: EventEmitter;
  loading: boolean;
  errors: Error[];

  updateValues: UpdateValues = (newLoading: boolean, newErrors: Error[]): void => {
    this.loading = newLoading;
    this.errors = newErrors;
    this.#trigger();
  };

  fetchExport: FetchExport = (params: QueryParams, exportType: string): Promise<boolean | null> => {
    this.updateValues(true, []);

    const url = exportType === 'summary' ? SMS_EXPORT_SUMMARY : SMS_EXPORT_DETAIL;

    return ApiService.request({
      method: 'get',
      url,
      params,
    })
      .catch((error) => {
        if (error?.response?.data?.violations) {
          this.updateValues(false, error.response.data.violations);
        }
        return Promise.reject();
      })
      .then(({ data }) => {
        if (data?.link) {
          window.open(data?.link, '_blank');
          return Promise.resolve(true);
        }
        return Promise.reject();
      });
  };

  onChange: OnChange = (listener: Listener): Function => {
    const listenerFunction = this.eventEmitter.addListener(listener);
    this.#trigger();
    return listenerFunction;
  };

  /**
   * @private
   */
  #trigger: Trigger = (): void => {
    this.eventEmitter.trigger({
      loading: this.loading,
      errors: this.errors,
    });
  };
}

const instance: GroupClassSmsExportService = new GroupClassSmsExportService();
export default instance;

